import React from 'react'
import Contactusbutton from './Contactusbutton'
import Contactform from './Contactform'


const Contact = () => {
  return (
    <div>
    <Contactform/>
     <Contactusbutton/> 
    
    </div>
  )
}

export default Contact
